const state = () => ({
  partners: {},
});

const getters = {
  get: (state) => state.partners,
  external: (state, getters) => getters['all'].filter(partner => partner.name !== 'HLT'),
  hlt: (state, getters) => getters['all'].find(partner => partner.name === 'HLT'),
  all: (state) => Object.keys(state.partners).map(id => state.partners[id]),
};

const mutations = {
  set: function(state, partners) {
    partners.forEach(partner => {
      state.partners[partner.id] = partner;
    });
  },
};

const actions = {
  fetchContentPartnerAssets({ dispatch, commit, getters, rootGetters }, params) {
    return rootGetters['session/ajax'].post('/content_partners/assets', params).then(({ data }) => {
      let topics = [];
      Object.keys(data).forEach(key => {
        if (data[key].topics) {
          topics = [...topics, ...data[key].topics];
        }
      });
      commit('topics/setTopics', topics, { root: true });

      let learningModules = [];
      Object.keys(data).forEach(key => {
        learningModules.concat(data[key].learningModules);
      });
      commit('learningModules/set', learningModules, { root: true });

      return data;
    });
  },
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
